export const educationData = [
    {
        id: 1,
        institution: 'Indian Institute of Information Technology, Sri City',
        course: 'B.Tech (CSE)',
        startYear: '2019',
        endYear: '2023',
        CGPA:'9.11'
    },
    {
        id: 2,
        institution: 'Sri Chaitanya College of Education, Vijayawada',
        course: 'Secondary Education',
        startYear: '2017',
        endYear: '2019',
        CGPA:'9.88'
    },
    {
        id: 3,
        institution: 'Narayana Olympiad School, Anantapur',
        course: 'Primary Education',
        startYear: '2016',
        endYear: '2017',
        CGPA:'10'
    },
]
